<template>
  <Flag v-if="countryCode" class="w-24" :country-code />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

const { allMarkets } = useMarketplace()
const currentLocale = useI18nLocale()

const countryCode = computed(() => {
  return Object.values(allMarkets).find(
    (market) => toBcp47Locale(market.defaultLocale) === currentLocale,
  )?.countryCode
})
</script>
